<template>
  <div :class="['container',  _isMobile()?'mobile':'']">
    <a-divider />
    <a-card class="search-card" :bordered="false">
      <j-dict-select-tag
        :defaultShowAll="true"
        type="radioButton"
        @change="handleChangeType"
        v-model="productType"
        :trigger-change="true"
        dictCode="product_type"
      />
    </a-card>
    <a-divider />
    <a-card :bordered="false">
      <a-skeleton v-if="loading"/>
      <a-list
        :grid="{ gutter: _isMobile()?12:24, lg: 4, md: 3, sm: 2, xs: 2 }"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" @click="toDetail(item.id)">
            <img class="cover" :src="item.productCover_url" alt="">
            <h3 class="title">{{ item.productName }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import {getAction} from "@/api/manage"
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      dataSource: [
      ],
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: this._isMobile()?8:12,
      },
      loading: true,
      productType: "",
      tenantConfig:{},
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getProdectList()
  },
  mounted(){
    window.document.title =  this.tenantConfig.brandName + " " + "认证产品"
  },
  methods: {
    handleChangeType(v) {
      this.productType = v.target.value
      this.getProdectList()
    },
    getProdectList(){
      this.loading = true
      this.dataSource = []
      getAction("/teaching/teachingProduct/list", {
        productType: this.productType, 
        pageSize:999, 
        // productStatus:2
        }).then(res=>{
        console.log(res);
        if(res.success){
          this.dataSource = res.result.records
        }
        this.loading = false
      })
    },
    toDetail(id){
      this.$router.push({
        path: '/production/detail',
        query: {
          id: id,
        },
      })
    }
  },
};
</script>

<style lang="less" scoped>
.cover{
  width: 100%;
  height: 170px;
}
.title{
  margin-top: 5px;
}
.title:hover{
  color: #1890FF;
}
.search-card{
  /deep/.ant-card-body{
    padding: 20px;
  }
}
/deep/.ant-list-item{
  cursor: pointer;
  .ant-card-body{
    padding: 0;
  }
}
.mobile{
  .cover{
    height: 100px!important;
  }
}
</style>